import { render, staticRenderFns } from "./page-agv-customer-details.vue?vue&type=template&id=b7250234&scoped=true&lang=pug&"
import script from "./page-agv-customer-details.vue?vue&type=script&lang=js&"
export * from "./page-agv-customer-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7250234",
  null
  
)

export default component.exports